<template>
  <div class="ac-snooze ac-card-content">
    <div class="ac-header-container">
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header">
        Export CSV
      </div>
    </div>
    <div class="ac-body-container">
      <div class="row-start margin-bottom-4">
        <SACRadio
          name="csv-type"
          field="csvType"
          value="hvac"
          :checked="csvType === 'hvac'"
          :change="handleChange"
          label="HVAC Profiles"
        />
        <SACRadio
          name="csv-type"
          field="csvType"
          value="system"
          :checked="csvType !== 'hvac'"
          :change="handleChange"
          label="System Health"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        No
      </button>
      <button
        type="button"
        class="ac-form-button"
        :disabled="processing"
        @click="handlePublish()"
      >
        <img
          v-if="processing"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span v-else>Yes</span>
      </button>
    </div>
  </div>
</template>

<script>
import systemHealthMixin from '@shared/mixins/systemHealthMixin';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import exportToFile from '@shared/lib/util/exportToFile';

export default {
  name: 'ExportCSVConfirmation',
  components: { SACRadio },
  mixins: [systemHealthMixin],
  data() {
    return {
      csvType: 'hvac',
    };
  },
  methods: {
    async handlePublish() {
      this.$store.dispatch('changeHomeValue', {
        field: 'processing',
        value: true,
      });
      let thatData;
      let filename;
      if (this.csvType === 'hvac') {
        thatData = await this.$store.dispatch('exportHVACProfilesData');
        filename = 'hvac-profiles.csv';
      } else {
        thatData = await this.$store.dispatch('exportSystemHealthData');
        filename = 'system-health.csv';
      }
      const payload = {
        data: thatData,
        filename,
      };

      exportToFile(payload);

      this.toggleActionModal(false);

      this.$store.dispatch('changeHomeValue', {
        field: 'processing',
        value: false,
      });
    },
    handleChange(field, value) {
      this[field] = value;
    },
  },
};
</script>
